module.exports = __webpack_public_path__ + "img/safe_car_2.e4fc2e19.png";